import { xEqualIntegrationVectorSimilarity } from "./xEqualIntegrationVectorSimilarity.js";
/**
 * Check the similarity between array created by xyMassCenterVector
 * @deprecated The center of mass trees it compares are misleading, see `xyMassCenterVector`.
 * Use `xEqualIntegrationVectorSimilarity` together with `xyEqualIntegrationVector`.
 * @param array1 - first mass center vector.
 * @param array2 - second mass center vector.
 * @param options - options.
 * @returns similarity score between 0 and 1.
 */
export function xMassCenterVectorSimilarity(array1, array2, options = {}) {
    const { recenter = true, similarityFct = (a, b) => (a === b ? 1 : 0), } = options;
    return xEqualIntegrationVectorSimilarity(array1, array2, {
        recenter,
        similarityFct,
    });
}
//# sourceMappingURL=xMassCenterVectorSimilarity.js.map